<div [ngClass]="getCss()" >
  <ng-content></ng-content>
</div>